import React, {memo} from 'react';
import MainRouter from './MainRouter';
import MainLayout from '@/layout/MainLayout';
import 'antd/es/slider/style';
import NewEmailDialog from '@/components/NewEmailDialog';
import {RenderViewTypeProvider} from '@/hooks/useRenderViewType';
import {CurrentClientProvider} from '@/hooks/useCurrentClient';
import {AsyncBreadcrumbsProvider} from '@/hooks/useAsyncBreadcrumbs';
import {AuditDataProvider} from '@/modules/auditorAudits/hooks/useAuditData';
import useIndexDbDexie from '@/hooks/useIndexDbDexie';
import {ShareAuditFromCalendarProvider} from '@/hooks/useShareAuditFromCalendar';
import {ShowIncidencesProvider} from '@/modules/auditorAudits/hooks/useShowIncidences';
import {ClientFilterProvider} from '@/hooks/useClientFilter';
import {AuditCalcProvider} from '@/modules/auditorAudits/hooks/useAuditCalc';

const MainApp = () => {

  const {db} = useIndexDbDexie();

  db?.open().catch((err) => {
    console.log(err.stack || err);
  });

  return (
    <AsyncBreadcrumbsProvider>
      <CurrentClientProvider>
        <ClientFilterProvider>
          <AuditDataProvider>
            <AuditCalcProvider>
              <ShowIncidencesProvider>
                <CurrentClientProvider>
                  <RenderViewTypeProvider>
                    <MainLayout>
                      <ShareAuditFromCalendarProvider>
                        <MainRouter/>
                        <NewEmailDialog/>
                      </ShareAuditFromCalendarProvider>
                    </MainLayout>
                  </RenderViewTypeProvider>
                </CurrentClientProvider>
              </ShowIncidencesProvider>
            </AuditCalcProvider>
          </AuditDataProvider>
        </ClientFilterProvider>
      </CurrentClientProvider>
    </AsyncBreadcrumbsProvider>
  );
};

export default memo(MainApp);
